<template>
  <div id="header-bar">
    <Button v-if="isNotMainMenuPage" absolute class="back-button" @onClick="onBack">
      <Icon icon="ion:chevron-back" class="txt-head"></Icon>
    </Button>
    <div class="d-flex justify-center align-end pa-4">
      <div class="txt-bigger font-weight-bold">{{ $route.name }}</div>
    </div>
  </div>
</template>

<script>
import Button from "./Button"
import { Icon } from '@iconify/vue2'
import { bottomNavMenus } from "../store/constants"

export default {
  name: "Header",
  components: {
    Button,
    Icon
  },
  computed: {
    isNotMainMenuPage: function () {
      let main_menus = bottomNavMenus.filter(item => !!item.to).map(item => item.to) || []
      return !main_menus.includes(this.$route.name)
    }
  },
  methods: {
    onBack() {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
#header-bar {
  min-height: var(--header-height);
  max-height: var(--header-height);
  background: var(--header-bg-color);
  position: relative;
  color: var(--font-theme-one);
  z-index: 10;

  >div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

.back-button {
  --btn-size: 36px;
  left: 12px;
  bottom: 12px;
  padding: 0 !important;
  border-radius: 50%;
  z-index: 20;
  min-width: var(--btn-size) !important;
  max-width: var(--btn-size) !important;
  min-height: var(--btn-size) !important;
  max-height: var(--btn-size) !important;
}
</style>